import React, { Component } from 'react'
import { ItemData } from '../apis/item.api'
import ContentAside from '../components/ContentAside'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import LocationSearchForm from '../partials/LocationSearchForm'
import LocationSearchItem from '../partials/LocationSearchItem'

interface LocationSearchProps {}

interface LocationSearchState {
  locationId: number | null
  bin: string
  activeItem: ItemData | null
}

export default class LocationSearch
  extends Component<LocationSearchProps, LocationSearchState> {
  constructor (props: LocationSearchProps) {
    super(props)
    this.state = {
      locationId: null,
      bin: '',
      activeItem: null
    }
    this.handleItemView = this.handleItemView.bind(this)
    this.handleItemClear = this.handleItemClear.bind(this)
  }

  get item () {
    const { activeItem, locationId, bin } = this.state
    return activeItem && locationId && bin &&
      <LocationSearchItem
        item={activeItem}
        locationId={locationId}
        bin={bin} />
  }

  reset () {
    const defaultState: LocationSearchState = {
      locationId: null,
      bin: '',
      activeItem: null
    }
    this.setState(defaultState)
  }

  handleItemView (activeItem: ItemData, locationId: number, bin: string) {
    this.setState({ activeItem, locationId, bin })
  }

  handleItemClear () {
    this.reset()
  }

  render () {
    return (
      <ContentLayout>
        <ContentMain layout="twoThird">
          <LocationSearchForm
            onItemView={this.handleItemView}
            onItemClear={this.handleItemClear} />
        </ContentMain>
        <ContentAside layout="oneThird">
          {this.item}
        </ContentAside>
      </ContentLayout>
    )
  }
}
